module.exports = __webpack_public_path__ + "static/kevinpatrickpouringsurup-4afa6227386944044400efde4e082626.jpg";